/** Een dag als YYYY-MM-DD, met jaar, maand en dag als groepen. Eén patroon voor de hele facturatie. */
const DATE_KEY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

/**
 * Een dag als YYYY-MM-DD leesbaar maken als DD-MM-YYYY. Iets wat geen dag is
 * komt ongewijzigd terug: liever de ruwe waarde dan een verzonnen datum.
 *
 * @param {string|undefined} dateKey
 * @returns {string}
 */
const formatDateKey = (dateKey) => {
    if (typeof dateKey !== 'string') return ''
    const match = DATE_KEY_PATTERN.exec(dateKey)
    return match ? `${match[3]}-${match[2]}-${match[1]}` : dateKey
}

export default formatDateKey
export { DATE_KEY_PATTERN }
